import React from 'react';
import Hero from '../../components/pages/Technology/Hero/Hero';
import RSP from '../../components/pages/Technology/RSP/RSP';
import Ecosystem from '../../components/pages/Technology/Ecosystem/Ecosystem';
import Footprint from '../../components/pages/Technology/Footprint/Footprint';
import Partners from '../../components/pages/Technology/Partners/Partners';
import TechOptimized from '../../components/pages/Technology/TechOptimized/TechOptimized';

const Technology = () => {
  return (
    <div>
      <Hero />
      <RSP />
      <Ecosystem />
      <Footprint />
      <Partners />
      <TechOptimized />
    </div>
  );
};

export default Technology;
